import React, { useContext, useEffect, useState } from 'react';
import './countdown.styles';
import { CountdownStyles } from './countdown.styles';
import { useTranslation } from 'react-i18next';
import AppContext from '../data/AppContext';
import { CHALLENGE_CONFIG } from '../challenge';
import { Trans } from 'react-i18next';
import Confetti from './confetti';

// Helper function to parse date strings consistently
const parseDate = (dateString) => {
  // Handle date format MM/DD/YYYY HH:MM:SS
  if (typeof dateString === 'string' && dateString.includes('/')) {
    const [datePart, timePart] = dateString.split(' ');
    const [month, day, year] = datePart.split('/');

    if (timePart) {
      const [hours, minutes, seconds] = timePart.split(':');
      return new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day),
        parseInt(hours),
        parseInt(minutes),
        parseInt(seconds)
      );
    } else {
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }
  }

  // Fallback to standard Date constructor
  return new Date(dateString);
};

const Countdown = () => {
  const [days, setDays] = useState(0);
  const { claimedMountainIds } = useContext(AppContext);

  const { t } = useTranslation('app');

  const [isChallengeEnded, setIsChallengeEnded] = useState(false);

  useEffect(() => {
    // Parse start and end dates
    const startDate = parseDate(CHALLENGE_CONFIG.startDate);
    const endDate = parseDate(CHALLENGE_CONFIG.endDate);

    const setDate = () => {
      const now = new Date();

      // If before challenge starts, show total days
      if (now < startDate) {
        const totalDays = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
        setDays(totalDays);
        setIsChallengeEnded(false);
        return;
      }

      // If after challenge ends, show 100 days
      if (now > endDate) {
        setDays(100);
        setIsChallengeEnded(true);
        return;
      }

      // During challenge: calculate remaining days INCLUDING today
      const diff = endDate.getTime() - now.getTime();
      const remainingDays = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
      setDays(remainingDays);
    };

    setDate();

    const interval = setInterval(() => {
      setDate();
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <CountdownStyles>
        {isChallengeEnded ? (
          <>
            <Trans
              i18nKey={t('counter.completed', { count: claimedMountainIds.length })}
              components={{ br: <br /> }}
            />
            <Confetti />
          </>
        ) : (
          t('counter.title')
        )}
        <div className="inner">
          <div className="segment">
            <span className="value">{days}</span>
            <span className="label">{t('counter.days')}</span>
          </div>
          <span className="divider"></span>
          <div className="segment">
            <span className="value">{claimedMountainIds.length}</span>
            <span className="label">{t('counter.mountains')}</span>
          </div>
        </div>
      </CountdownStyles>
    </>
  );
};

export default Countdown;